import React from 'react'

const Ellipsis = ({ children, style }) => (
	<div
		style={{
			display: 'table',
			tableLayout: 'fixed',
			whiteSpace: 'nowrap',
			width: '100%',
			...(style || {}),
		}}
	>
		<span
			style={{
				display: 'table-cell',
				overflow: 'hidden',
				textOverflow: 'ellipsis',
			}}
		>
			{children}
		</span>
	</div>
)

export default Ellipsis
